var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconModem64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.244 42.3994H9.77904C8.24425 42.3994 7 43.5705 7 45.015V51.554C7 52.9985 8.24425 54.1696 9.77904 54.1696H54.244C55.7788 54.1696 57.023 52.9985 57.023 51.554V45.015C57.023 43.5705 55.7788 42.3994 54.244 42.3994Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1841 20.3301V42.3991",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1841 48.2852H24.6553",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7241 48.2852H48.1954",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3677 48.2852H40.8389",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5512 21.995C25.5826 21.995 27.2294 20.3483 27.2294 18.3168C27.2294 16.2855 25.5826 14.6387 23.5512 14.6387C21.5198 14.6387 19.873 16.2855 19.873 18.3168C19.873 20.3483 21.5198 21.995 23.5512 21.995Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3812 14.4443C14.502 15.739 13.9883 17.3018 13.9883 18.9847C13.9883 20.6431 14.4871 22.185 15.343 23.4685",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1214 11.5029C8.84503 13.4632 8.10352 15.8036 8.10352 18.3172C8.10352 20.8382 8.84945 23.1849 10.1326 25.1487",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6826 13.9707C32.5618 15.2654 33.0756 16.8283 33.0756 18.5112C33.0756 20.1696 32.5767 21.7114 31.7208 22.9948",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9424 11.6973C38.2187 13.6575 38.9603 15.998 38.9603 18.5115C38.9603 21.0326 38.2144 23.3793 36.9312 25.3431",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconModem64);
export default __webpack_public_path__ + "static/media/pictogramBeaconModem64.3de6aaafe367dab95be9ef88818c9272.svg";
export { ForwardRef as ReactComponent };